/** Typed caller for /api/v1/retail/sales (plan 05, RT-01). */
import { ApiError, type ErrorEnvelope, isErrorCode, type schemas } from '@gym/shared';

import type { GymSupabaseClient } from '../supabase.js';

export interface RetailSaleResult {
  sale_id: string;
  payment_id: string;
  total: number;
  fiscal_status: 'issued' | 'failed_retriable' | 'failed' | 'not_required';
  fiscal_receipt_id?: string;
  device_receipt_number?: string;
  fiscal_qr_payload?: string | null;
}

export async function recordRetailSale(
  client: GymSupabaseClient,
  req: schemas.RecordRetailSaleRequest,
  idempotencyKey: string = crypto.randomUUID(),
): Promise<RetailSaleResult> {
  const { data, error } = await client.functions.invoke<RetailSaleResult | ErrorEnvelope>(
    'retail-sale',
    {
      headers: { 'Idempotency-Key': idempotencyKey },
      body: req,
    },
  );
  if (error) throw new ApiError('internal_error', { message: error.message, cause: error });
  if (data && typeof data === 'object' && 'error' in data && (data as ErrorEnvelope).error) {
    const env = (data as ErrorEnvelope).error;
    throw new ApiError(isErrorCode(env.code) ? env.code : 'internal_error', {
      message: env.message,
      ...(env.details !== undefined ? { details: env.details } : {}),
      requestId: env.request_id,
      retriable: env.retriable,
    });
  }
  return data as RetailSaleResult;
}
